import { COLORS, FILES_PATH, IMAGES } from "../constants";
const {
  E_SDG_logo01,
  E_SDG_logo02,
  E_SDG_logo03,
  E_SDG_logo04,
  E_SDG_logo05,
  E_SDG_logo06,
  E_SDG_logo07,
  E_SDG_logo08,
  E_SDG_logo09,
  E_SDG_logo10,
  E_SDG_logo11,
  E_SDG_logo12,
  E_SDG_logo13,
  E_SDG_logo14,
  E_SDG_logo15,
  E_SDG_logo16,
  E_SDG_logo17,
} = IMAGES;
const dataSdgAndSub = [
  {
    id: 1,
    sub: false,
    header: "เป้าหมายที่ 1",
    description: "ยุติความยากจนทุกรูปแบบในทุกที่",
    meta: "",
    image: E_SDG_logo01,
  },
  {
    id: 1,
    sub: true,
    header: "เป้าหมายย่อย 1.1",
    description: "",
    description2:
      "ขจัดความยากจนขั้นรุนแรงของประชาชนในทุกพื้นที่ให้หมดไปภายในปี พ.ศ. 2573 ซึ่งปัจจุบันความยากจนวัดจากคนที่มีค่าใช้จ่ายดำรงชีพรายวันต่ำกว่า $1.90 ต่อวัน",
    meta: "",
    image: "",
  },
  {
    id: 1,
    sub: true,
    header: "เป้าหมายย่อย 1.2",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ลดสัดส่วน ชาย หญิง และเด็ก ในทุกช่วงวัย ที่อยู่ภายใต้ความยากจนในทุกมิติ ตามนิยามของแต่ละประเทศ ให้ลดลงอย่างน้อยครึ่งหนึ่ง",
    meta: "",
    image: "",
  },
  {
    id: 1,
    sub: true,
    header: "เป้าหมายย่อย 1.3",
    description: "",
    description2:
      "ดำเนินการระบบและมาตรการคุ้มครองทางสังคมที่เหมาะสมในทุกระดับ และให้มีการครอบคลุมในวงกว้างกับกลุ่มที่ยากจนและเปราะบางที่สุดภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 1,
    sub: true,
    header: "เป้าหมายย่อย 1.4",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 สร้างหลักประกันว่าชายและหญิง โดยเฉพาะกลุ่มที่ยากจนและเปราะบาง มีสิทธิในทรัพย์สินทางเศรษฐกิจ เข้าถึงบริการพื้นฐาน และมีสิทธิในการเป็นเจ้าของและควบคุมที่ดิน ทรัพย์สินทางธรรมชาติ และแหล่งทรัพยากรอย่างเหมาะสม",
    meta: "",
    image: "",
  },
  {
    id: 1,
    sub: true,
    header: "เป้าหมายย่อย 1.5",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 สร้างความเข้มแข็งให้กับคนจนและคนในภาวะเปราะบางเพื่อรองรับภัยพิบัติและความเสี่ยงทางเศรษฐกิจ สังคม และสิ่งแวดล้อม",
    meta: "",
    image: "",
  },
  {
    id: 1,
    sub: true,
    header: "เป้าหมายย่อย 1.A",
    description: "",
    description2:
      "สร้างหลักประกันว่าประเทศกำลังพัฒนา โดยเฉพาะประเทศที่พัฒนาน้อยที่สุด มีทรัพยากรเพียงพอที่จะดำเนินการตามนโยบายและโครงการเพื่อยุติความยากจนในทุกรูปแบบ",
    meta: "",
    image: "",
  },
  {
    id: 1,
    sub: true,
    header: "เป้าหมายย่อย 1.B",
    description: "",
    description2:
      "สร้างหลักประกันว่าประเทศกำลังพัฒนา โดยเฉพาะประเทศที่พัฒนาน้อยที่สุด มีทรัพยากรเพียงพอที่จะดำเนินการตามนโยบายและโครงการเพื่อยุติความยากจนในทุกรูปแบบ",
    meta: "",
    image: "",
  },
  {
    id: 2,
    sub: false,
    header: "เป้าหมายที่ 2",
    description:
      "ยุติความหิวโหย บรรลุความมั่นคงทางอาหาร และส่งเสริมการเกษตรที่ยั่งยืน",
    meta: "",
    image: E_SDG_logo02,
    amount: 0,
  },
  {
    id: 2,
    sub: true,
    header: "เป้าหมายย่อย 2.1",
    description: "",
    description2:
      "   ยุติความหิวโหยและสร้างหลักประกันให้ทุกคนโดยเฉพาะคนที่ยากจนและอยู่ในภาวะเปราะบาง อันรวมถึงทารก ได้เข้าถึงอาหารที่ปลอดภัย มีโภชนาการ และเพียงพอตลอดทั้งปี ภายในปีพ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 2,
    sub: true,
    header: "เป้าหมายย่อย 2.2",
    description: "",
    description2:
      "ยุติภาวะทุพโภชนาการทุกรูปแบบภายในปี พ.ศ. 2573 รวมทั้งบรรลุเป้าหมายที่ตกลงร่วมกันระหว่างประเทศว่าด้วยการเติบโตในช่วง 10 ปีข้างหน้าเพื่อเด็กอายุต่ำกว่า 5 ปี ในด้านภาวะน้ำหนักต่ำกว่าเกณฑ์ และภาวะเตี้ยแคระ",
    meta: "",
    image: "",
  },
  {
    id: 2,
    sub: true,
    header: "เป้าหมายย่อย 2.3",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 เพิ่มการผลิตทางการเกษตรและรายได้ของเกษตรกรรายย่อย โดยเฉพาะผู้หญิง ชนพื้นเมือง ครอบครัวเกษตรกรรายย่อยที่มีทรัพยากรจำกัด ผ่านการเข้าถึงที่ดิน เครื่องมือการผลิต และการเข้าถึงตลาด",
    meta: "",
    image: "",
  },
  {
    id: 2,
    sub: true,
    header: "เป้าหมายย่อย 2.4",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ทำให้ระบบการผลิตอาหารมีความยั่งยืนและเพิ่มขีดความสามารถในการปรับตัวต่อสภาพภูมิอากาศที่เปลี่ยนแปลง รวมทั้งปรับปรุงที่ดินและดินเพาะปลูกที่มีคุณภาพ",
    meta: "",
    image: "",
  },
  {
    id: 2,
    sub: true,
    header: "เป้าหมายย่อย 2.5",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ธำรงรักษาความหลากหลายทางพันธุกรรมของเมล็ดพันธุ์และพืชเพาะปลูกและปศุสัตว์และพันธุ์สัตว์ป่า ตลอดจนเข้าถึงและแบ่งปันผลประโยชน์ที่เกิดจากการใช้ทรัพยากรพันธุกรรม",
    meta: "",
    image: "",
  },
  {
    id: 2,
    sub: true,
    header: "เป้าหมายย่อย 2.A",
    description: "",
    description2:
      "เพิ่มการลงทุนในโครงสร้างพื้นฐานและเทคโนโลยีการเกษตร รวมทั้งวิจัยและพัฒนาด้านการเกษตรและระบบชลประทานเพื่อเพิ่มประสิทธิภาพและผลิตภาพการเกษตร",
    meta: "",
    image: "",
  },
  {
    id: 2,
    sub: true,
    header: "เป้าหมายย่อย 2.B",
    description: "",
    description2:
      "แก้ไขและป้องกันข้อจำกัดทางการค้าทางการเกษตรที่ทำให้เกิดการบิดเบือนตลาดโลก รวมทั้งการยกเลิกการอุดหนุนการส่งออกทางการเกษตรที่มีผลเสียต่อประเทศกำลังพัฒนา",
    meta: "",
    image: "",
  },
  {
    id: 2,
    sub: true,
    header: "เป้าหมายย่อย 2.C",
    description: "",
    description2:
      "สร้างหลักประกันว่า การทำงานของตลาดสินค้าเกษตรและอนุพันธ์มีความมั่นคงและไม่แปรปรวน เพื่อช่วยให้การเข้าถึงข้อมูลด้านตลาดที่ทันสมัย รวมถึงข้อมูลเกี่ยวกับปริมาณสำรองอาหารเพื่อลดความแปรปรวนของราคาอาหาร",
    meta: "",
    image: "",
  },
  {
    id: 3,
    sub: false,
    header: "เป้าหมายที่ 3",
    description:
      "สร้างหลักประกันว่ามีชีวิตที่มีสุขภาพดีและส่งเสริมความเป็นอยู่ที่ดีสำหรับทุกคนในทุกวัย",
    meta: "",
    image: E_SDG_logo03,
  },
  {
    id: 3,
    sub: true,
    header: "เป้าหมายย่อย 3.1",
    description: "",
    description2:
      "สร้างหลักประกันว่ามีชีวิตที่มีสุขภาพดีและส่งเสริมความเป็นอยู่ที่ดีสำหรับทุกคนในทุกวัย",
    meta: "",
    image: "",
  },
  {
    id: 3,
    sub: true,
    header: "เป้าหมายย่อย 3.2",
    description: "",
    description2:
      "    ยุติการตายที่ป้องกันได้ของทารกแรกเกิดและเด็กอายุต่ำกว่า 5 ปี โดยทุกประเทศมุ่งลดอัตราการตายในทารกลงให้ต่ำถึง 12 คน ต่อการเกิดมีชีพ 1,000 คน และลดอัตราการตายในเด็กอายุต่ำกว่า 5 ปี ลงให้ต่ำถึง 25 คน ต่อการเกิดมีชีพ 1,000 คน ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 3,
    sub: true,
    header: "เป้าหมายย่อย 3.3",
    description: "",
    description2:
      "ยุติการแพร่กระจายของเอดส์ วัณโรค มาลาเรีย และโรคเขตร้อนที่ถูกละเลย และต่อสู้กับโรคตับอักเสบ โรคติดต่อทางน้ำและโรคติดต่ออื่นๆ ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 3,
    sub: true,
    header: "เป้าหมายย่อย 3.4",
    description: "",
    description2:
      "ลดการตายก่อนวัยอันควรจากโรคไม่ติดต่อให้ลดลงหนึ่งในสาม ผ่านทางการป้องกันและการรักษาโรค และสนับสนุนสุขภาพจิตและความเป็นอยู่ที่ดี ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },

  {
    id: 4,
    sub: false,
    header: "เป้าหมายที่ 4",
    description:
      "สร้างหลักประกันว่าทุกคนมีการศึกษาที่มีคุณภาพอย่างครอบคลุมและเท่าเทียม และสนับสนุนโอกาสในการเรียนรู้ตลอดชีวิต",
    meta: "",
    image: E_SDG_logo04,
  },
  {
    id: 4,
    sub: true,
    header: "เป้าหมายย่อย 4.1",
    description: "",
    description2:
      " สร้างหลักประกันว่าเด็กชายและเด็กหญิงทุกคนสำเร็จการศึกษาระดับประถมศึกษาและมัธยมศึกษาที่มีคุณภาพ เท่าเทียม และไม่มีค่าใช้จ่าย นำไปสู่ผลลัพธ์ทางการเรียนที่มีประสิทธิผล ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 4,
    sub: true,
    header: "เป้าหมายย่อย 4.2",
    description: "",
    description2:
      "สร้างหลักประกันว่าทุกคนมีโอกาสเข้าถึงการพัฒนาเด็กปฐมวัย การดูแล และการศึกษาปฐมวัยที่มีคุณภาพ โดยเฉพาะอย่างยิ่งกลุ่มที่ด้อยโอกาส ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 4,
    sub: true,
    header: "เป้าหมายย่อย 4.3",
    description: "",
    description2:
      "สร้างหลักประกันว่าผู้หญิงและผู้ชายทุกคนเข้าถึงการศึกษาระดับอุดมศึกษาและการเรียนรู้ตลอดชีวิตในราคาที่เหมาะสมและเท่าเทียม โดยเฉพาะอย่างยิ่งกลุ่มที่ด้อยโอกาส ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 4,
    sub: true,
    header: "เป้าหมายย่อย 4.4",
    description: "",
    description2:
      "เพิ่มจำนวนเยาวชนและผู้ใหญ่ที่มีทักษะที่เกี่ยวข้องรวมถึงทักษะทางเทคนิคและอาชีวะ เพื่อการจ้างงานที่มีประสิทธิผลและการเป็นผู้ประกอบการ ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 4,
    sub: true,
    header: "เป้าหมายย่อย 4.5",
    description: "",
    description2:
      "ขจัดความเหลื่อมล้ำทางเพศในด้านการศึกษาและสร้างหลักประกันว่ากลุ่มที่ด้อยโอกาสรวมถึงคนพิการ ชนกลุ่มน้อย และเด็กในสถานการณ์เปราะบาง มีโอกาสเข้าถึงการศึกษาทุกระดับและการฝึกอบรมในสายอาชีพอย่างเท่าเทียม ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 4,
    sub: true,
    header: "เป้าหมายย่อย 4.6",
    description: "",
    description2:
      "สร้างหลักประกันว่าคนหนุ่มสาวและผู้ใหญ่ทุกคน โดยเฉพาะอย่างยิ่งผู้หญิง ได้เรียนรู้การอ่านออกเขียนได้และการคำนวณ ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 4,
    sub: true,
    header: "เป้าหมายย่อย 4.7",
    description: "",
    description2:
      "สร้างหลักประกันว่าผู้เรียนทุกคนได้รับความรู้และทักษะที่จำเป็นสำหรับการส่งเสริมการพัฒนาที่ยั่งยืน รวมถึงการศึกษาเพื่อการพัฒนาที่ยั่งยืนและวิถีชีวิตที่ยั่งยืน สิทธิมนุษยชน ความเสมอภาคทางเพศ การส่งเสริมวัฒนธรรมแห่งสันติภาพและการไม่ใช้ความรุนแรง สัญชาติที่เป็นพลเมืองโลก และการเห็นคุณค่าในความหลากหลายทางวัฒนธรรมและการมีส่วนร่วมของวัฒนธรรมเพื่อการพัฒนาที่ยั่งยืน ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 4,
    sub: true,
    header: "เป้าหมายย่อย 4.a",
    description: "",
    description2:
      "สร้างและยกระดับสถานศึกษาที่ปลอดภัย มีความครอบคลุมและมีความไว้วางใจได้ รวมถึงการจัดหาสิ่งอำนวยความสะดวกที่เหมาะสม สภาพแวดล้อมการเรียนรู้ที่มีความปลอดภัย สุขอนามัย และการสนับสนุนที่ดีสำหรับทุกคน ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 4,
    sub: true,
    header: "เป้าหมายย่อย 4.b",
    description: "",
    description2:
      "ขยายทุนการศึกษาไปยังประเทศกำลังพัฒนา โดยเฉพาะอย่างยิ่งประเทศที่มีรายได้น้อย และประเทศที่มีความต้องการพิเศษอื่น ๆ เพื่อให้สามารถเข้าถึงการศึกษาระดับอุดมศึกษาได้มากขึ้น ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 4,
    sub: true,
    header: "เป้าหมายย่อย 4.c",
    description: "",
    description2:
      "เพิ่มจำนวนครูที่มีคุณภาพ รวมถึงผ่านความร่วมมือระหว่างประเทศเพื่อการฝึกอบรมครูในประเทศกำลังพัฒนา โดยเฉพาะอย่างยิ่งในประเทศที่มีรายได้น้อย ภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 5,
    sub: false,
    header: "เป้าหมายที่ 5",
    description:
      "บรรลุความเสมอภาคระหว่างเพศและให้อำนาจของผู้หญิงและเด็กหญิงทุกคน",
    meta: "",
    image: E_SDG_logo05,
  },
  {
    id: 5,
    sub: true,
    header: "เป้าหมายย่อย 5.1",
    description: "",
    description2: "ยุติการเลือกปฏิบัติทุกรูปแบบต่อสตรีและเด็กหญิงในทุกที่",
    meta: "",
    image: "",
  },
  {
    id: 5,
    sub: true,
    header: "เป้าหมายย่อย 5.2",
    description: "",
    description2:
      "ขจัดความรุนแรงทุกรูปแบบต่อสตรีและเด็กหญิงในพื้นที่สาธารณะและเอกชน รวมถึงการค้ามนุษย์และการแสวงหาผลประโยชน์ทางเพศ และการกระทำที่ไม่เหมาะสมอื่นๆ",
    meta: "",
    image: "",
  },
  {
    id: 5,
    sub: true,
    header: "เป้าหมายย่อย 5.3",
    description: "",
    description2:
      "ขจัดการกระทำที่ก่อให้เกิดอันตรายต่อสุขภาพและการละเมิดสิทธิมนุษยชนต่อเด็กหญิง รวมถึงการแต่งงานในวัยเด็ก การบังคับแต่งงาน และการขลิบอวัยวะเพศหญิง",
    meta: "",
    image: "",
  },
  {
    id: 5,
    sub: true,
    header: "เป้าหมายย่อย 5.4",
    description: "",
    description2:
      "สร้างการรับรู้และการแบ่งปันภาระงานบ้านที่ไม่มีค่าจ้าง รวมถึงการดูแลที่ไม่ได้รับค่าจ้าง ผ่านการจัดหาบริการสาธารณะ โครงสร้างพื้นฐาน และนโยบายการคุ้มครองสังคม และการส่งเสริมการรับผิดชอบร่วมกันในครอบครัวและครัวเรือนตามความเหมาะสม",
    meta: "",
    image: "",
  },
  {
    id: 5,
    sub: true,
    header: "เป้าหมายย่อย 5.5",
    description: "",
    description2:
      "สร้างหลักประกันว่าผู้หญิงมีส่วนร่วมเต็มที่และมีโอกาสเท่าเทียมในการเป็นผู้นำในทุกระดับของการตัดสินใจในชีวิตทางการเมือง เศรษฐกิจ และสาธารณะ",
    meta: "",
    image: "",
  },
  {
    id: 5,
    sub: true,
    header: "เป้าหมายย่อย 5.6",
    description: "",
    description2:
      "สร้างหลักประกันว่าผู้หญิงสามารถเข้าถึงบริการด้านสุขภาพทางเพศและอนามัยเจริญพันธุ์ได้ รวมถึงสิทธิเชิงเจริญพันธุ์ตามที่ตกลงกันในระดับสากล",
    meta: "",
    image: "",
  },
  {
    id: 5,
    sub: true,
    header: "เป้าหมายย่อย 5.A",
    description: "",
    description2:
      "ดำเนินการปฏิรูปเพื่อให้สิทธิที่เท่าเทียมกันต่อทรัพยากรทางเศรษฐกิจ รวมถึงการเข้าถึงการเป็นเจ้าของและควบคุมที่ดิน และรูปแบบอื่น ๆ ของทรัพย์สินทางเศรษฐกิจ การเงิน บริการ การสืบทอด และทรัพยากรธรรมชาติตามกฎหมายของประเทศ",
    meta: "",
    image: "",
  },
  {
    id: 5,
    sub: true,
    header: "เป้าหมายย่อย 5.B",
    description: "",
    description2:
      "ปรับใช้เทคโนโลยีที่เสริมสร้างศักยภาพของผู้หญิง โดยเฉพาะอย่างยิ่งในด้านเทคโนโลยีสารสนเทศและการสื่อสาร",
    meta: "",
    image: "",
  },
  {
    id: 5,
    sub: true,
    header: "เป้าหมายย่อย 5.C",
    description: "",
    description2:
      "สร้างนโยบายและกฎหมายที่เสริมสร้างความเสมอภาคทางเพศ และให้อำนาจผู้หญิงและเด็กหญิงทุกคนในทุกระดับ",
    meta: "",
    image: "",
  },
  {
    id: 6,
    sub: false,
    header: "เป้าหมายที่ 6",
    description:
      "สร้างหลักประกันเรื่องน้ำและการสุขาภิบาลให้มีการจัดการอย่างยั่งยืน และมีสภาพพร้อมใช้สำหรับทุกคน",
    meta: "",
    image: E_SDG_logo06,
  },

  {
    id: 6,
    sub: true,
    header: "เป้าหมายย่อย 6.3",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ปรับปรุงคุณภาพน้ำโดยลดมลพิษ การทิ้งของเสีย และการปล่อยสารเคมีอันตรายลงสู่แหล่งน้ำ และเพิ่มการนำกลับมาใช้ใหม่ของน้ำอย่างยั่งยืน",
    meta: "",
    image: "",
  },
  {
    id: 6,
    sub: true,
    header: "เป้าหมายย่อย 6.4",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 เพิ่มประสิทธิภาพการใช้น้ำในทุกภาคส่วน และสร้างหลักประกันว่ามีการจัดการทรัพยากรน้ำอย่างยั่งยืน",
    meta: "",
    image: "",
  },
  {
    id: 6,
    sub: true,
    header: "เป้าหมายย่อย 6.5",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 จัดการน้ำในลักษณะบูรณาการในทุกระดับ รวมถึงผ่านความร่วมมือข้ามพรมแดนตามความเหมาะสม",
    meta: "",
    image: "",
  },
  {
    id: 6,
    sub: true,
    header: "เป้าหมายย่อย 6.6",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ปกป้องและฟื้นฟูระบบนิเวศที่เกี่ยวข้องกับน้ำ เช่น ป่าไม้ พื้นที่ชุ่มน้ำ แม่น้ำ และทะเลสาบ",
    meta: "",
    image: "",
  },
  {
    id: 6,
    sub: true,
    header: "เป้าหมายย่อย 6.A",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ขยายความร่วมมือระหว่างประเทศและการสนับสนุนการพัฒนาขีดความสามารถสำหรับประเทศกำลังพัฒนาในด้านกิจกรรมและโปรแกรมเกี่ยวกับน้ำและสุขอนามัย",
    meta: "",
    image: "",
  },
  {
    id: 6,
    sub: true,
    header: "เป้าหมายย่อย 6.B",
    description: "",
    description2:
      "สนับสนุนและเสริมสร้างการมีส่วนร่วมของชุมชนในด้านการจัดการน้ำและสุขาภิบาล",
    meta: "",
    image: "",
  },

  {
    id: 7,
    sub: false,
    header: "เป้าหมายที่ 7",
    description:
      "สร้างหลักประกันว่าทุกคนเข้าถึงพลังงานสมัยใหม่ในราคาที่สามารถซื้อหาได้ เชื่อถือได้ และยั่งยืน",
    meta: "",
    image: E_SDG_logo07,
  },
  {
    id: 7,
    sub: true,
    header: "เป้าหมายย่อย 7.2",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 เพิ่มสัดส่วนของพลังงานหมุนเวียนในพลังงานที่ใช้ทั้งหมด",
    meta: "",
    image: "",
  },
  {
    id: 7,
    sub: true,
    header: "เป้าหมายย่อย 7.3",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 เพิ่มอัตราการปรับปรุงประสิทธิภาพการใช้พลังงานทั่วโลกให้เป็นสองเท่า",
    meta: "",
    image: "",
  },
  {
    id: 7,
    sub: true,
    header: "เป้าหมายย่อย 7.A",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 เพิ่มความร่วมมือระหว่างประเทศในการอำนวยความสะดวกในการเข้าถึงการวิจัยและเทคโนโลยีพลังงานสะอาด รวมถึงพลังงานหมุนเวียน ประสิทธิภาพพลังงาน และเทคโนโลยีที่ใช้เชื้อเพลิงฟอสซิลสะอาด และส่งเสริมการลงทุนในโครงสร้างพื้นฐานพลังงานและเทคโนโลยีพลังงานสะอาด",
    meta: "",
    image: "",
  },
  {
    id: 7,
    sub: true,
    header: "เป้าหมายย่อย 7.B",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ขยายโครงสร้างพื้นฐานและปรับปรุงเทคโนโลยีเพื่อให้บริการพลังงานที่ยั่งยืนและทันสมัยแก่ทุกคนในประเทศกำลังพัฒนา โดยเฉพาะประเทศพัฒนาน้อยที่สุด ประเทศกำลังพัฒนาที่ไม่มีทางออกสู่ทะเล และรัฐกำลังพัฒนาที่เป็นเกาะ",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: false,
    header: "เป้าหมายที่ 8",
    description:
      "ส่งเสริมการเติบโตทางเศรษฐกิจที่ต่อเนื่อง ครอบคลุม และยั่งยืน การจ้างงานเต็มที่ และมีผลิตภาพ และการมีงานที่สมควรสำหรับทุกคน",
    meta: "",
    image: E_SDG_logo08,
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.1",
    description: "",
    description2:
      "ธำรงรักษาการเติบโตทางเศรษฐกิจต่อหัวประชากรให้สอดคล้องกับบริบทของชาติ โดยเฉพาะการเติบโตของผลิตภัณฑ์มวลรวมในประเทศอย่างน้อยร้อยละ 7 ต่อปีในประเทศพัฒนาน้อยที่สุด",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.2",
    description: "",
    description2:
      "บรรลุระดับที่สูงขึ้นของผลิตภาพทางเศรษฐกิจผ่านการกระจายความหลากหลาย การอัพเกรดเทคโนโลยีและนวัตกรรม รวมถึงมุ่งเน้นภาคส่วนที่มีมูลค่าเพิ่มสูงและการใช้แรงงานเข้มข้น",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.3",
    description: "",
    description2:
      "ส่งเสริมการพัฒนานโยบายที่มุ่งเน้นการพัฒนาการทำงานอย่างมีคุณค่า สร้างโอกาสในการจ้างงาน ส่งเสริมการประกอบการ ความคิดสร้างสรรค์ และนวัตกรรม และกระตุ้นการเติบโตของวิสาหกิจขนาดกลางและขนาดย่อม",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.4",
    description: "",
    description2:
      "ปรับปรุงประสิทธิภาพการผลิตและการบริโภคทรัพยากรอย่างยั่งยืน โดยตั้งเป้าลดการใช้ทรัพยากรธรรมชาติต่อหน่วยของกิจกรรมทางเศรษฐกิจ",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.5",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 บรรลุการจ้างงานเต็มรูปแบบและการทำงานที่มีคุณค่าพร้อมทั้งได้รับค่าตอบแทนที่เท่าเทียมสำหรับผู้ชายและผู้หญิงทุกคน",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.6",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 ลดสัดส่วนเยาวชนที่ไม่ได้อยู่ในระบบการศึกษา การฝึกอบรม หรือการทำงานลงอย่างมีนัยสำคัญ",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.7",
    description: "",
    description2:
      "ดำเนินมาตรการทันทีและมีประสิทธิภาพเพื่อขจัดแรงงานทาส รูปแบบของการบังคับแรงงาน การค้ามนุษย์ และแรงงานเด็ก",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.8",
    description: "",
    description2:
      "ปกป้องสิทธิแรงงานและส่งเสริมการสร้างสภาพแวดล้อมการทำงานที่ปลอดภัยและเป็นมิตรสำหรับแรงงานทุกคน รวมถึงแรงงานข้ามชาติและแรงงานที่ไม่มั่นคง",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.9",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 วางนโยบายเพื่อส่งเสริมการท่องเที่ยวอย่างยั่งยืนที่สร้างงานและส่งเสริมวัฒนธรรมและผลิตภัณฑ์ท้องถิ่น",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.10",
    description: "",
    description2:
      "เสริมสร้างขีดความสามารถของสถาบันการเงินในประเทศเพื่อขยายการเข้าถึงบริการทางการเงินสำหรับทุกคน",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.A",
    description: "",
    description2:
      "เพิ่มการสนับสนุนด้านการค้าเพื่อการพัฒนาให้แก่ประเทศกำลังพัฒนา โดยเฉพาะประเทศพัฒนาน้อยที่สุด ผ่านกรอบการดำเนินงานของการช่วยเหลือด้านการค้า",
    meta: "",
    image: "",
  },
  {
    id: 8,
    sub: true,
    header: "เป้าหมายย่อย 8.B",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 พัฒนาและดำเนินกลยุทธ์ระดับโลกเพื่อการจ้างงานเยาวชนและดำเนินการตามกฎบัตรขององค์การสหประชาชาติเพื่อการจ้างงานเยาวชน",
    meta: "",
    image: "",
  },

  {
    id: 9,
    sub: false,
    header: "เป้าหมายที่ 9",
    description:
      "สร้างโครงสร้างพื้นฐานที่มีความทนทาน ส่งเสริมการพัฒนาอุตสาหกรรมที่ครอบคลุมและยั่งยืน และส่งเสริมนวัตกรรม",
    meta: "",
    image: E_SDG_logo09,
  },
  {
    id: 9,
    sub: true,
    header: "เป้าหมายย่อย 9.1",
    description: "",
    description2:
      "พัฒนาโครงสร้างพื้นฐานที่มีความเสถียร ยั่งยืน และมีคุณภาพสูง เพื่อสนับสนุนการพัฒนาทางเศรษฐกิจและความเป็นอยู่ของมนุษย์",
    meta: "",
    image: "",
  },
  {
    id: 9,
    sub: true,
    header: "เป้าหมายย่อย 9.2",
    description: "",
    description2:
      "ส่งเสริมการยกระดับอุตสาหกรรมอย่างมีส่วนร่วมและยั่งยืน และเพิ่มสัดส่วนการจ้างงานและผลิตภัณฑ์มวลรวมในประเทศในภาคอุตสาหกรรมให้สอดคล้องกับบริบทของประเทศ",
    meta: "",
    image: "",
  },
  {
    id: 9,
    sub: true,
    header: "เป้าหมายย่อย 9.3",
    description: "",
    description2:
      "เพิ่มการเข้าถึงบริการทางการเงินสำหรับวิสาหกิจขนาดเล็กและขนาดย่อม",
    meta: "",
    image: "",
  },
  {
    id: 9,
    sub: true,
    header: "เป้าหมายย่อย 9.4",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ยกระดับโครงสร้างพื้นฐานและอุตสาหกรรมให้มีความยั่งยืนโดยเพิ่มประสิทธิภาพการใช้ทรัพยากรและการใช้เทคโนโลยีที่สะอาด",
    meta: "",
    image: "",
  },
  {
    id: 9,
    sub: true,
    header: "เป้าหมายย่อย 9.5",
    description: "",
    description2:
      "เพิ่มการลงทุนในการวิจัยและพัฒนา และสนับสนุนการพัฒนาเทคโนโลยีพื้นฐานอุตสาหกรรมและนวัตกรรมในประเทศกำลังพัฒนา",
    meta: "",
    image: "",
  },
  {
    id: 9,
    sub: true,
    header: "เป้าหมายย่อย 9.A",
    description: "",
    description2:
      "อำนวยความสะดวกในการพัฒนาโครงสร้างพื้นฐานที่ยั่งยืนและแข็งแกร่งในประเทศกำลังพัฒนา",
    meta: "",
    image: "",
  },
  {
    id: 9,
    sub: true,
    header: "เป้าหมายย่อย 9.B",
    description: "",
    description2:
      "สนับสนุนการพัฒนาเทคโนโลยีพื้นฐาน อุตสาหกรรมที่มีนวัตกรรมใหม่ และการลงทุนในงานวิจัยและพัฒนาในประเทศกำลังพัฒนา",
    meta: "",
    image: "",
  },
  {
    id: 9,
    sub: true,
    header: "เป้าหมายย่อย 9.C",
    description: "",
    description2:
      "เพิ่มการเข้าถึงเทคโนโลยีการสื่อสารและสารสนเทศสำหรับทุกคน และพยายามให้สามารถใช้อินเทอร์เน็ตในราคาที่เหมาะสมในประเทศที่พัฒนาน้อยที่สุด",
    meta: "",
    image: "",
  },
  {
    id: 10,
    sub: false,
    header: "เป้าหมายที่ 10",
    description: "ลดความไม่เสมอภาคภายในและระหว่างประเทศ",
    meta: "",
    image: E_SDG_logo10,
  },
  {
    id: 10,
    sub: true,
    header: "เป้าหมายย่อย 10.1",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 บรรลุอัตราการเติบโตของรายได้ของประชากรกลุ่มที่มีรายได้ต่ำสุดให้สูงกว่าค่าเฉลี่ยของประเทศ",
    meta: "",
    image: "",
  },
  {
    id: 10,
    sub: true,
    header: "เป้าหมายย่อย 10.2",
    description: "",
    description2:
      "ส่งเสริมการมีส่วนร่วมของทุกคนในทางเศรษฐกิจ สังคม และการเมือง และขจัดการกีดกันทุกรูปแบบ",
    meta: "",
    image: "",
  },
  {
    id: 10,
    sub: true,
    header: "เป้าหมายย่อย 10.3",
    description: "",
    description2:
      "ทำให้มั่นใจว่าทุกคนจะได้รับโอกาสอย่างเท่าเทียมกัน และลดความไม่เท่าเทียมกันโดยการขจัดกฎหมาย นโยบาย และการปฏิบัติที่เลือกปฏิบัติ",
    meta: "",
    image: "",
  },
  {
    id: 10,
    sub: true,
    header: "เป้าหมายย่อย 10.4",
    description: "",
    description2:
      "นำมาตรการทางนโยบายมาใช้ โดยเฉพาะอย่างยิ่งนโยบายด้านการคลัง การค้า และการจ้างงาน เพื่อให้บรรลุความเท่าเทียมกันมากขึ้น",
    meta: "",
    image: "",
  },
  {
    id: 10,
    sub: true,
    header: "เป้าหมายย่อย 10.5",
    description: "",
    description2:
      "ปรับปรุงกฎระเบียบและการติดตามตรวจสอบตลาดการเงินและสถาบันการเงินทั่วโลกให้สอดคล้องกับกฎหมายและมาตรฐาน",
    meta: "",
    image: "",
  },
  {
    id: 10,
    sub: true,
    header: "เป้าหมายย่อย 10.6",
    description: "",
    description2:
      "ประกันให้ประเทศกำลังพัฒนาเพิ่มบทบาทในการตัดสินใจในสถาบันเศรษฐกิจและการเงินระหว่างประเทศเพื่อเพิ่มประสิทธิภาพ ความน่าเชื่อถือ ความรับผิดชอบ และความชอบธรรม",
    meta: "",
    image: "",
  },
  {
    id: 10,
    sub: true,
    header: "เป้าหมายย่อย 10.7",
    description: "",
    description2:
      "อำนวยความสะดวกในการโยกย้ายถิ่นฐานและการเคลื่อนย้ายแรงงานอย่างเป็นระเบียบ ปลอดภัย เป็นปกติและมีความรับผิดชอบ รวมถึงการนำเสนอนโยบายการโยกย้ายถิ่นฐานที่มีการวางแผนและมีการจัดการที่ดี",
    meta: "",
    image: "",
  },
  {
    id: 10,
    sub: true,
    header: "เป้าหมายย่อย 10.A",
    description: "",
    description2:
      "ดำเนินการตามหลักการพิเศษและแตกต่างขององค์การการค้าโลก (WTO) สำหรับประเทศกำลังพัฒนา โดยเฉพาะประเทศพัฒนาน้อยที่สุด",
    meta: "",
    image: "",
  },
  {
    id: 10,
    sub: true,
    header: "เป้าหมายย่อย 10.B",
    description: "",
    description2:
      "สนับสนุนความช่วยเหลือเพื่อการพัฒนาและการไหลเวียนของเงินทุนจากต่างประเทศไปยังประเทศที่ต้องการความช่วยเหลือมากที่สุด โดยเฉพาะประเทศพัฒนาน้อยที่สุด",
    meta: "",
    image: "",
  },
  {
    id: 10,
    sub: true,
    header: "เป้าหมายย่อย 10.C",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ลดต้นทุนธุรกรรมการโอนเงินของแรงงานข้ามชาติเหลือร้อยละ 3 และขจัดช่องทางการโอนเงินที่มีค่าธรรมเนียมสูงกว่าร้อยละ 5",
    meta: "",
    image: "",
  },

  {
    id: 11,
    sub: false,
    header: "เป้าหมายที่ 11",
    description:
      "ทำให้เมืองและการตั้งถิ่นฐานของมนุษย์มีความปลอดภัย ทั่วถึง พร้อมรับการเปลี่ยนแปลงและยั่งยืน",
    meta: "",
    image: E_SDG_logo11,
  },
  {
    id: 11,
    sub: true,
    header: "เป้าหมายย่อย 11.1",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 มั่นใจว่าทุกคนสามารถเข้าถึงที่อยู่อาศัยและบริการพื้นฐานที่เพียงพอ ปลอดภัย และราคาไม่แพง และพัฒนาชุมชนแออัด",
    meta: "",
    image: "",
  },
  {
    id: 11,
    sub: true,
    header: "เป้าหมายย่อย 11.2",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 มั่นใจว่าทุกคนสามารถเข้าถึงระบบขนส่งที่ปลอดภัย ราคาไม่แพง สามารถเข้าถึงได้ และยั่งยืน",
    meta: "",
    image: "",
  },
  {
    id: 11,
    sub: true,
    header: "เป้าหมายย่อย 11.3",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 เพิ่มการพัฒนาเมืองและการตั้งถิ่นฐานของมนุษย์อย่างครอบคลุมและยั่งยืน และเพิ่มการวางแผนการตั้งถิ่นฐานของมนุษย์อย่างมีส่วนร่วมและบูรณาการ",
    meta: "",
    image: "",
  },
  {
    id: 11,
    sub: true,
    header: "เป้าหมายย่อย 11.4",
    description: "",
    description2:
      "เสริมสร้างความพยายามในการปกป้องและอนุรักษ์มรดกทางวัฒนธรรมและธรรมชาติของโลก",
    meta: "",
    image: "",
  },
  {
    id: 11,
    sub: true,
    header: "เป้าหมายย่อย 11.5",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ลดจำนวนผู้เสียชีวิตและจำนวนผู้ที่ได้รับผลกระทบจากภัยพิบัติ รวมถึงลดการสูญเสียทางเศรษฐกิจที่เกี่ยวเนื่องกับ GDP",
    meta: "",
    image: "",
  },
  {
    id: 11,
    sub: true,
    header: "เป้าหมายย่อย 11.6",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ลดผลกระทบด้านลบต่อสิ่งแวดล้อมในเมืองต่อหัวประชากร โดยให้ความสำคัญกับคุณภาพอากาศและการจัดการของเสียของเมืองและการกำจัดของเสีย",
    meta: "",
    image: "",
  },
  {
    id: 11,
    sub: true,
    header: "เป้าหมายย่อย 11.7",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ให้บริการพื้นที่สีเขียวและพื้นที่สาธารณะที่ปลอดภัย ครอบคลุม และเข้าถึงได้สำหรับทุกคน โดยเฉพาะสตรี เด็ก ผู้สูงอายุ และผู้พิการ",
    meta: "",
    image: "",
  },
  {
    id: 11,
    sub: true,
    header: "เป้าหมายย่อย 11.A",
    description: "",
    description2:
      "สนับสนุนการวางแผนและการบริหารจัดการการพัฒนาเมืองอย่างบูรณาการและยั่งยืนในเชิงบูรณาการ",
    meta: "",
    image: "",
  },
  {
    id: 11,
    sub: true,
    header: "เป้าหมายย่อย 11.B",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 เพิ่มจำนวนเมืองและชุมชนที่ใช้แผนพัฒนาชุมชนอย่างบูรณาการและครอบคลุม เพื่อเสริมสร้างความสามารถในการปรับตัวต่อการเปลี่ยนแปลงสภาพภูมิอากาศ ภัยพิบัติ และการจัดการอย่างยั่งยืน",
    meta: "",
    image: "",
  },
  {
    id: 11,
    sub: true,
    header: "เป้าหมายย่อย 11.C",
    description: "",
    description2:
      "สนับสนุนประเทศพัฒนาน้อยที่สุดในการสร้างอาคารที่ยั่งยืนและฟื้นตัวได้โดยใช้วัสดุท้องถิ่น",
    meta: "",
    image: "",
  },
  {
    id: 12,
    sub: false,
    header: "เป้าหมายที่ 12",
    description: "สร้างหลักประกันให้มีแบบแผนการผลิตและการบริโภคที่ยั่งยืน",
    meta: "",
    image: E_SDG_logo12,
  },
  {
    id: 12,
    sub: true,
    header: "เป้าหมายย่อย 12.1",
    description: "",
    description2:
      "ดำเนินการตามกรอบ 10 ปี ว่าด้วยการบริโภคและการผลิตที่ยั่งยืน โดยทุกประเทศเป็นผู้นำในการดำเนินการ",
    meta: "",
    image: "",
  },
  {
    id: 12,
    sub: true,
    header: "เป้าหมายย่อย 12.2",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 บรรลุการจัดการทรัพยากรธรรมชาติอย่างยั่งยืนและการใช้ทรัพยากรอย่างมีประสิทธิภาพ",
    meta: "",
    image: "",
  },
  {
    id: 12,
    sub: true,
    header: "เป้าหมายย่อย 12.3",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ลดขยะอาหารต่อหัวทั่วโลกในระดับผู้บริโภคและค้าปลีกลงครึ่งหนึ่ง และลดการสูญเสียอาหารตามห่วงโซ่อุปทานและหลังการเก็บเกี่ยว",
    meta: "",
    image: "",
  },
  {
    id: 12,
    sub: true,
    header: "เป้าหมายย่อย 12.4",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 บรรลุการจัดการสารเคมีและของเสียทุกประเภทตลอดวงจรชีวิตของพวกมันอย่างปลอดภัย",
    meta: "",
    image: "",
  },
  {
    id: 12,
    sub: true,
    header: "เป้าหมายย่อย 12.5",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ลดการสร้างของเสียอย่างมีนัยสำคัญผ่านการป้องกัน การลด การรีไซเคิล และการใช้ซ้ำ",
    meta: "",
    image: "",
  },
  {
    id: 12,
    sub: true,
    header: "เป้าหมายย่อย 12.6",
    description: "",
    description2:
      "สนับสนุนให้บริษัท โดยเฉพาะบริษัทขนาดใหญ่และข้ามชาติ ใช้แนวปฏิบัติที่ยั่งยืนและผนวกข้อมูลด้านความยั่งยืนไว้ในรายงานประจำปี",
    meta: "",
    image: "",
  },
  {
    id: 12,
    sub: true,
    header: "เป้าหมายย่อย 12.7",
    description: "",
    description2:
      "ส่งเสริมการปฏิบัติด้านการจัดซื้อจัดจ้างภาครัฐที่ยั่งยืนตามนโยบายและลำดับความสำคัญระดับชาติ",
    meta: "",
    image: "",
  },
  {
    id: 12,
    sub: true,
    header: "เป้าหมายย่อย 12.8",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ประกันว่าผู้คนทุกที่มีข้อมูลและการรับรู้ที่เกี่ยวข้องและมีความตระหนักรู้เกี่ยวกับการพัฒนาที่ยั่งยืนและวิถีชีวิตที่กลมกลืนกับธรรมชาติ",
    meta: "",
    image: "",
  },
  {
    id: 12,
    sub: true,
    header: "เป้าหมายย่อย 12.A",
    description: "",
    description2:
      "สนับสนุนประเทศกำลังพัฒนาในการเสริมสร้างขีดความสามารถทางวิทยาศาสตร์และเทคโนโลยี เพื่อขับเคลื่อนการเปลี่ยนผ่านไปสู่รูปแบบการบริโภคและการผลิตที่ยั่งยืนมากขึ้น",
    meta: "",
    image: "",
  },
  {
    id: 12,
    sub: true,
    header: "เป้าหมายย่อย 12.B",
    description: "",
    description2:
      "พัฒนาและดำเนินการตามเครื่องมือเพื่อใช้ติดตามผลกระทบต่อการพัฒนาที่ยั่งยืนสำหรับการท่องเที่ยวที่ยั่งยืน",
    meta: "",
    image: "",
  },
  {
    id: 12,
    sub: true,
    header: "เป้าหมายย่อย 12.C",
    description: "",
    description2:
      "หาเหตุและแก้ไขการบิดเบือนตลาดที่เกิดจากการอุดหนุนพลังงานเชื้อเพลิงฟอสซิล",
    meta: "",
    image: "",
  },
  {
    id: 13,
    sub: false,
    header: "เป้าหมายที่ 13",
    description:
      "ปฎิบัติการอย่างเร่งด่วยเพื่อต่อสู้กับการเปลี่ยนแปลงสภาพภูมิอากาศและผลกระทบที่เกิดขึ้น",
    meta: "",
    image: E_SDG_logo13,
  },
  {
    id: 13,
    sub: true,
    header: "เป้าหมายย่อย 13.1",
    description: "",
    description2:
      "เสริมสร้างความสามารถในการปรับตัวต่อภัยพิบัติที่เกี่ยวข้องกับการเปลี่ยนแปลงสภาพภูมิอากาศและภัยธรรมชาติในทุกประเทศ",
    meta: "",
    image: "",
  },
  {
    id: 13,
    sub: true,
    header: "เป้าหมายย่อย 13.2",
    description: "",
    description2:
      "บูรณาการมาตรการด้านการเปลี่ยนแปลงสภาพภูมิอากาศเข้าไปในการวางแผน นโยบาย และกลยุทธ์ของประเทศ",
    meta: "",
    image: "",
  },
  {
    id: 13,
    sub: true,
    header: "เป้าหมายย่อย 13.3",
    description: "",
    description2:
      "ปรับปรุงการศึกษา การสร้างความตระหนักรู้ และขีดความสามารถของมนุษย์และสถาบันต่าง ๆ ในการบรรเทาผลกระทบจากการเปลี่ยนแปลงสภาพภูมิอากาศ การปรับตัว การลดผลกระทบ และการเตือนภัยล่วงหน้า",
    meta: "",
    image: "",
  },
  {
    id: 13,
    sub: true,
    header: "เป้าหมายย่อย 13.A",
    description: "",
    description2:
      "ดำเนินการตามคำมั่นสัญญาที่ให้ไว้กับประเทศพัฒนาแล้วใน UNFCCC โดยมีเป้าหมายเพื่อระดมทุนร่วมกันจำนวน 100 พันล้านดอลลาร์สหรัฐฯ ต่อปีภายในปี พ.ศ. 2563 เพื่อแก้ไขปัญหาความต้องการของประเทศกำลังพัฒนา",
    meta: "",
    image: "",
  },
  {
    id: 13,
    sub: true,
    header: "เป้าหมายย่อย 13.B",
    description: "",
    description2:
      "ส่งเสริมกลไกเพื่อเพิ่มขีดความสามารถในการวางแผนและการจัดการที่มีประสิทธิภาพเกี่ยวกับการเปลี่ยนแปลงสภาพภูมิอากาศในประเทศพัฒนาน้อยที่สุดและรัฐกำลังพัฒนาที่เป็นเกาะ โดยมุ่งเน้นที่ผู้หญิง เยาวชน และชุมชนท้องถิ่นและชายขอบ",
    meta: "",
    image: "",
  },
  {
    id: 14,
    sub: false,
    header: "เป้าหมายที่ 14",
    description:
      "อนุรักษ์และใช้ประโยชน์จากมหาสมุทร ทะเลและทรัพยากรทางทะเลและทรัพยากรทางทะเลอย่างยั่งยืนเพื่อการพัฒนาที่ยั่งยืน",
    meta: "",
    image: E_SDG_logo14,
  },

  {
    id: 14,
    sub: true,
    header: "เป้าหมายย่อย 14.1",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2568 ป้องกันและลดมลพิษทางทะเลทุกชนิดอย่างมีนัยสำคัญ โดยเฉพาะจากกิจกรรมบนบก รวมถึงขยะทะเลและมลพิษทางสารอาหาร",
    meta: "",
    image: "",
  },
  {
    id: 14,
    sub: true,
    header: "เป้าหมายย่อย 14.2",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 จัดการและปกป้องระบบนิเวศทางทะเลและชายฝั่งอย่างยั่งยืน เพื่อหลีกเลี่ยงผลกระทบที่สำคัญ รวมทั้งเสริมสร้างความสามารถในการฟื้นฟู เพื่อให้ทะเลมีสุขภาพดีและมีผลผลิต",
    meta: "",
    image: "",
  },
  {
    id: 14,
    sub: true,
    header: "เป้าหมายย่อย 14.3",
    description: "",
    description2:
      "ลดและแก้ไขผลกระทบของการเพิ่มความเป็นกรดของมหาสมุทร รวมถึงเพิ่มความร่วมมือทางวิทยาศาสตร์ในทุกระดับ",
    meta: "",
    image: "",
  },
  {
    id: 14,
    sub: true,
    header: "เป้าหมายย่อย 14.4",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 ควบคุมการทำประมงที่ผิดกฎหมาย ไม่มีการรายงาน และไร้การควบคุม และการทำประมงในลักษณะที่ทำลายล้าง และดำเนินการตามแผนการบริหารจัดการอย่างมีประสิทธิภาพ เพื่อฟื้นฟูปริมาณปลาตามลำดับความสำคัญ",
    meta: "",
    image: "",
  },
  {
    id: 14,
    sub: true,
    header: "เป้าหมายย่อย 14.5",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 อนุรักษ์อย่างน้อยร้อยละ 10 ของพื้นที่ชายฝั่งและทะเลให้สอดคล้องกับกฎหมายระหว่างประเทศและบนพื้นฐานของข้อมูลทางวิทยาศาสตร์ที่ดีที่สุด",
    meta: "",
    image: "",
  },
  {
    id: 14,
    sub: true,
    header: "เป้าหมายย่อย 14.6",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 ห้ามการอุดหนุนการประมงที่นำไปสู่การประมงที่ผิดกฎหมาย ไม่มีการรายงาน และไร้การควบคุม และการทำประมงที่มากเกินขนาด",
    meta: "",
    image: "",
  },
  {
    id: 14,
    sub: true,
    header: "เป้าหมายย่อย 14.7",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 เพิ่มผลประโยชน์ทางเศรษฐกิจแก่รัฐกำลังพัฒนาที่เป็นเกาะขนาดเล็กและประเทศพัฒนาน้อยที่สุดจากการใช้ทรัพยากรทางทะเลอย่างยั่งยืน รวมถึงผ่านการจัดการอย่างยั่งยืนของการประมง การเพาะเลี้ยงสัตว์น้ำ และการท่องเที่ยว",
    meta: "",
    image: "",
  },
  {
    id: 14,
    sub: true,
    header: "เป้าหมายย่อย 14.A",
    description: "",
    description2:
      "เพิ่มความรู้ทางวิทยาศาสตร์ พัฒนาองค์ความรู้ในการวิจัย และถ่ายทอดเทคโนโลยีทางทะเล",
    meta: "",
    image: "",
  },
  {
    id: 14,
    sub: true,
    header: "เป้าหมายย่อย 14.B",
    description: "",
    description2:
      "เพิ่มการเข้าถึงทรัพยากรทางทะเลและตลาดสำหรับชาวประมงรายย่อยขนาดเล็ก",
    meta: "",
    image: "",
  },
  {
    id: 14,
    sub: true,
    header: "เป้าหมายย่อย 14.C",
    description: "",
    description2: "เพิ่มการอนุรักษ์และการใช้มหาสมุทรและทรัพยากรอย่างยั่งยืน",
    meta: "",
    image: "",
  },

  {
    id: 15,
    sub: false,
    header: "เป้าหมายที่ 15",
    description:
      "ปกป้อง ฟื้นฟู และสนับสนุนการใช้ระบบนิเวศบนบกอย่างยั่งยืน จัดการป่าไม้อย่างยั่งยืน ต่อสู้การกลายสภาพเป็นทะเลทราย หยุดการเสื่อมโทรมของที่ดินและฟื้นสภาพกลับมาใหม่ และหยุดการสูญเสียความหลากหลายทางชีวภาพ",
    meta: "",
    image: E_SDG_logo15,
  },

  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.1",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ปกป้อง ฟื้นฟู และส่งเสริมการใช้ระบบนิเวศทางบกและน้ำจืดอย่างยั่งยืน เช่น ป่าไม้ พื้นที่ชุ่มน้ำ ภูเขา และพื้นที่แห้งแล้ง",
    meta: "",
    image: "",
  },
  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.2",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 ส่งเสริมการจัดการป่าไม้อย่างยั่งยืน หยุดการทำลายป่า ฟื้นฟูพื้นที่ป่าที่เสื่อมโทรม และเพิ่มการปลูกป่าทั่วโลก",
    meta: "",
    image: "",
  },
  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.3",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ต่อสู้กับการแปรสภาพเป็นทะเลทราย ฟื้นฟูที่ดินและดินที่เสื่อมโทรม รวมถึงที่ดินที่ได้รับผลกระทบจากการแปรสภาพเป็นทะเลทราย ภัยแล้ง และน้ำท่วม และมุ่งมั่นที่จะบรรลุการทำให้ความเสื่อมโทรมของที่ดินเป็นศูนย์",
    meta: "",
    image: "",
  },
  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.4",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ปกป้องระบบนิเวศภูเขา รวมถึงความหลากหลายทางชีวภาพ เพื่อเพิ่มศักยภาพในการให้ประโยชน์ที่จำเป็นต่อการพัฒนาที่ยั่งยืน",
    meta: "",
    image: "",
  },
  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.5",
    description: "",
    description2:
      "ดำเนินการอย่างเร่งด่วนและสำคัญเพื่อลดการเสื่อมสภาพของแหล่งที่อยู่อาศัยตามธรรมชาติ หยุดการสูญเสียความหลากหลายทางชีวภาพ และปกป้องและป้องกันการสูญพันธุ์ของสิ่งมีชีวิตที่ถูกคุกคาม",
    meta: "",
    image: "",
  },
  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.6",
    description: "",
    description2:
      "ส่งเสริมการเข้าถึงและการแบ่งปันผลประโยชน์อย่างยุติธรรมจากการใช้ทรัพยากรพันธุกรรมตามข้อตกลงระหว่างประเทศ",
    meta: "",
    image: "",
  },
  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.7",
    description: "",
    description2:
      "ดำเนินการอย่างเร่งด่วนเพื่อยุติการลักลอบค้าที่ผิดกฎหมายและการค้ายาเสพติดในสัตว์ป่าและพันธุ์พืชที่ได้รับการปกป้อง",
    meta: "",
    image: "",
  },
  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.8",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 ดำเนินมาตรการเพื่อป้องกันการแพร่กระจายและลดผลกระทบของสิ่งมีชีวิตต่างถิ่นรุกราน",
    meta: "",
    image: "",
  },
  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.9",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 บูรณาการคุณค่าความหลากหลายทางชีวภาพและระบบนิเวศเข้าไปในกระบวนการวางแผนระดับชาติ กระบวนการพัฒนา กลยุทธ์ และการลดความยากจน",
    meta: "",
    image: "",
  },
  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.A",
    description: "",
    description2:
      "ระดมและเพิ่มทรัพยากรทางการเงินจากทุกแหล่งเพื่ออนุรักษ์และใช้ความหลากหลายทางชีวภาพและระบบนิเวศอย่างยั่งยืน",
    meta: "",
    image: "",
  },
  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.B",
    description: "",
    description2:
      "ระดมทรัพยากรทางการเงินอย่างมากมายจากทุกแหล่งและในทุกระดับเพื่ออนุรักษ์และใช้ความหลากหลายทางชีวภาพและระบบนิเวศอย่างยั่งยืน",
    meta: "",
    image: "",
  },
  {
    id: 15,
    sub: true,
    header: "เป้าหมายย่อย 15.C",
    description: "",
    description2:
      "เพิ่มการสนับสนุนระดับโลกในการต่อสู้กับการลักลอบค้าที่ผิดกฎหมายในทรัพยากรธรรมชาติ",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: false,
    header: "เป้าหมายที่ 16",
    description:
      "ส่งเสริมสังคมที่สงบสุขและครอบคลุม เพื่อการพัฒนาที่ยั่งยืน ให้ทุกคนเข้าถึงความยุติธรรม และสร้างสถาบันที่มีประสิทธิผล รับผิดชอบ และครอบคลุมในทุกระดับ",
    meta: "",
    image: E_SDG_logo16,
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.1",
    description: "",
    description2:
      "ลดความรุนแรงทุกรูปแบบและอัตราการตายที่เกี่ยวข้องในทุกสถานที่",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.2",
    description: "",
    description2:
      "ยุติการละเมิด การแสวงหาประโยชน์ การค้ามนุษย์ และความรุนแรงทุกรูปแบบต่อเด็ก",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.3",
    description: "",
    description2:
      "ส่งเสริมหลักนิติธรรมในระดับประเทศและระหว่างประเทศและสร้างความมั่นใจในการเข้าถึงความยุติธรรมอย่างเท่าเทียมกันสำหรับทุกคน",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.4",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 ลดการไหลเวียนของอาวุธผิดกฎหมายและการเงินผิดกฎหมายอย่างมีนัยสำคัญ",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.5",
    description: "",
    description2: "ลดการทุจริตและสินบนในทุกรูปแบบอย่างมีนัยสำคัญ",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.6",
    description: "",
    description2: "พัฒนาสถาบันที่มีประสิทธิภาพ รับผิดชอบ และโปร่งใสในทุกระดับ",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.7",
    description: "",
    description2:
      "สร้างความมั่นใจในการตัดสินใจอย่างตอบสนอง ครอบคลุม มีส่วนร่วม และเป็นตัวแทนในทุกระดับ",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.8",
    description: "",
    description2:
      "ขยายและเสริมสร้างการมีส่วนร่วมของประเทศกำลังพัฒนาในสถาบันการปกครองโลก",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.9",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 จัดให้ทุกคนมีเอกลักษณ์ทางกฎหมาย รวมถึงการจดทะเบียนเกิด",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.10",
    description: "",
    description2:
      "สร้างความมั่นใจในการเข้าถึงข้อมูลและปกป้องเสรีภาพพื้นฐานตามกฎหมายและข้อตกลงระหว่างประเทศ",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.A",
    description: "",
    description2:
      "เสริมสร้างสถาบันระดับชาติที่เกี่ยวข้อง โดยเฉพาะในประเทศกำลังพัฒนา ผ่านความร่วมมือระหว่างประเทศ",
    meta: "",
    image: "",
  },
  {
    id: 16,
    sub: true,
    header: "เป้าหมายย่อย 16.B",
    description: "",
    description2:
      "ส่งเสริมและบังคับใช้กฎหมายและนโยบายที่ไม่เลือกปฏิบัติเพื่อการพัฒนาที่ยั่งยืน",
    meta: "",
    image: "",
  },

  {
    id: 17,
    sub: false,
    header: "เป้าหมายที่ 17",
    description:
      "เสริมความเข้มแข็งให้แก่กลไกการดำเนินงานและฟื้นฟูสภาพหุ้นส่วนความร่วมมือระดับโลกสำหรับการพัฒนาที่ยั่งยืน",
    meta: "",
    image: E_SDG_logo17,
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.1",
    description: "",
    description2:
      "เสริมสร้างการระดมทรัพยากรภายในประเทศ เพื่อปรับปรุงขีดความสามารถของประเทศกำลังพัฒนาในการเก็บรวบรวมรายได้ภายในประเทศ",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.2",
    description: "",
    description2:
      "ให้ประเทศพัฒนาแล้วปฏิบัติตามคำมั่นสัญญาของความช่วยเหลือเพื่อการพัฒนาอย่างเป็นทางการ โดยให้ประเทศพัฒนาแล้วบริจาคเงิน ODA ร้อยละ 0.7 ของรายได้ประชาชาติรวม และร้อยละ 0.15-0.20 ของรายได้ประชาชาติรวมสำหรับประเทศพัฒนาน้อยที่สุด",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.3",
    description: "",
    description2:
      "ระดมทรัพยากรทางการเงินเพิ่มเติมจากแหล่งต่างๆ เพื่อประเทศกำลังพัฒนา",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.4",
    description: "",
    description2:
      "ช่วยประเทศกำลังพัฒนาในการบรรลุการปลดเปลื้องหนี้ที่ยั่งยืนในระยะยาวผ่านนโยบายและมาตรการต่างๆ เพื่อขจัดหนี้ที่มีภาระหนัก",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.5",
    description: "",
    description2: "ใช้การลงทุนส่งเสริมการพัฒนาที่เน้นประเทศพัฒนาน้อยที่สุด",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.6",
    description: "",
    description2:
      "เสริมสร้างความร่วมมือในระดับใต้-ใต้ ความร่วมมือไตรภาคี และความร่วมมือในระดับภูมิภาคและระหว่างภูมิภาค ในการเข้าถึงวิทยาศาสตร์ เทคโนโลยี และนวัตกรรม และเพิ่มการแบ่งปันความรู้ร่วมกันตามข้อตกลงที่ตกลงร่วมกัน",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.7",
    description: "",
    description2:
      "ส่งเสริมการพัฒนา การถ่ายทอด การเผยแพร่ และการเผยแพร่เทคโนโลยีที่เหมาะสมต่อประเทศกำลังพัฒนาภายใต้เงื่อนไขที่ดี รวมถึงเงื่อนไขพิเศษและเป็นที่นิยมตามที่ตกลงร่วมกัน",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.8",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 ดำเนินการตามเทคโนโลยีสารสนเทศและการสื่อสารที่ตั้งขึ้นอย่างเต็มที่ของคณะกรรมาธิการวิทยาศาสตร์และเทคโนโลยีเพื่อการพัฒนาและเพิ่มขีดความสามารถทางเทคโนโลยีในประเทศพัฒนาน้อยที่สุด",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.9",
    description: "",
    description2:
      "เสริมสร้างการสนับสนุนระหว่างประเทศเพื่อดำเนินการเสริมสร้างขีดความสามารถที่มีประสิทธิภาพและมุ่งเน้นในประเทศกำลังพัฒนาเพื่อสนับสนุนแผนการระดับชาติในการดำเนินการตามเป้าหมายการพัฒนาที่ยั่งยืนทั้งหมด",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.10",
    description: "",
    description2:
      "ส่งเสริมระบบการค้าแบบพหุภาคีที่เป็นสากล เปิดกว้าง ยุติธรรม ไม่เลือกปฏิบัติและเที่ยงธรรมภายใต้องค์การการค้าโลก",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.11",
    description: "",
    description2:
      "เพิ่มการส่งออกของประเทศกำลังพัฒนา โดยเฉพาะอย่างยิ่งตั้งเป้าเพื่อเพิ่มส่วนแบ่งการส่งออกทั่วโลกเป็นสองเท่าสำหรับประเทศพัฒนาน้อยที่สุดภายในปี พ.ศ. 2573",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.12",
    description: "",
    description2:
      "ตระหนักถึงการดำเนินการตามโครงการปรับปรุงความสัมพันธ์ทางการค้าระหว่างประเทศระหว่างประเทศพัฒนาแล้วกับประเทศพัฒนาน้อยที่สุดโดยไม่มีข้อผูกพัน",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.13",
    description: "",
    description2:
      "เสริมสร้างเสถียรภาพของเศรษฐกิจมหภาคทั่วโลก รวมถึงผ่านการประสานนโยบายและการบรรลุความสอดคล้องของนโยบาย",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.14",
    description: "",
    description2: "เพิ่มความสอดคล้องของนโยบายเพื่อการพัฒนาที่ยั่งยืน",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.15",
    description: "",
    description2:
      "เคารพพื้นที่นโยบายและความเป็นผู้นำของประเทศต่างๆ ในการจัดตั้งและดำเนินการตามนโยบายเพื่อขจัดความยากจนและการพัฒนาที่ยั่งยืน",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.16",
    description: "",
    description2:
      "เสริมสร้างความร่วมมือระดับโลกเพื่อการพัฒนาที่ยั่งยืน โดยได้รับการสนับสนุนจากหุ้นส่วนระดับพหุภาคีที่เสริมสร้างและฟื้นฟูการเป็นหุ้นส่วนระดับโลกเพื่อการพัฒนาที่ยั่งยืน",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.17",
    description: "",
    description2:
      "ส่งเสริมและส่งเสริมความร่วมมือระดับประชาสังคมอย่างมีประสิทธิภาพและมีประสิทธิผลต่อการสร้างความร่วมมือภาครัฐและเอกชนและภาคประชาสังคมโดยอิงจากประสบการณ์ของการเป็นหุ้นส่วน",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.18",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2563 เพิ่มขีดความสามารถในการสนับสนุนประเทศกำลังพัฒนา โดยเฉพาะประเทศพัฒนาน้อยที่สุดและรัฐกำลังพัฒนาที่เป็นเกาะเล็ก ๆ",
    meta: "",
    image: "",
  },
  {
    id: 17,
    sub: true,
    header: "เป้าหมายย่อย 17.19",
    description: "",
    description2:
      "ภายในปี พ.ศ. 2573 สร้างระบบสถิติที่มีประสิทธิภาพในการวัดความก้าวหน้าทางการพัฒนาที่ยั่งยืนในประเทศกำลังพัฒนา",
    meta: "",
    image: "",
  },
];
export default dataSdgAndSub;